/**
 * The Carbon chart theme (lib/themeColors getChartTheme) for recharts props,
 * re-read whenever the in-app theme changes. Recharts takes colors as SVG
 * attributes, which can't resolve var(), so the values are read from the
 * computed tokens. The re-read runs in a passive effect: ThemeProvider puts
 * `.light` on <html> in a layout effect that runs after its children's, so a
 * read during the first render can still see the previous theme.
 */
import { useEffect, useState } from 'react'
import { useTheme } from '@/context/ThemeContext'
import { getChartTheme, type ChartTheme } from '@/lib/themeColors'

export function useChartTheme(): ChartTheme {
  const { theme } = useTheme()
  const [chartTheme, setChartTheme] = useState<ChartTheme>(getChartTheme)
  useEffect(() => {
    setChartTheme(getChartTheme())
  }, [theme])
  return chartTheme
}
